export const GET_OWNERS_AUTH = 'GET_OWNERS_AUTH';
export const GET_OWNERS_SUCCESS_AUTH = 'GET_OWNERS_SUCCESS_AUTH';
export const GET_OWNERS_FAILURE_AUTH = 'GET_OWNERS_FAILURE_AUTH';

export const DEFAULT_AUTH_STATE = 'DEFAULT_AUTH_STATE';

export const LOGOUT = 'LOGOUT';
